'use client';

import React from 'react';

import { Icon, IconName, IconSize, Link } from '@bytel/trilogy-react';

import { getClientCookies } from '@helpers/cookies-client';

export type BackLinkProps = {
    baseUrl: string;
    type: string;
    previousPageLabel: string;
};

export function BackLink({ baseUrl, type, previousPageLabel }: BackLinkProps) {
    const wallFilter = getClientCookies(`${type}WallFilter`);
    const href = wallFilter ? `${baseUrl}/${wallFilter}` : baseUrl;

    return (
        <Link className='is-flex is-aligned-center p-small' href={href}>
            <Icon name={IconName.ARROW_LEFT} size={IconSize.SMALL} />
            {previousPageLabel}
        </Link>
    );
}
